var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoadingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Download_x5F_25_x25_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Download_x5F_50_x25_"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Download_x5F_75_x25_"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Download_x5F_100_x25_"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Upload"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Next"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Last"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "OK"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Fail"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Add"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Spinner_x5F_0_x25_"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Spinner_x5F_25_x25_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M50.188,26.812 c12.806,0,23.188,10.381,23.188,23.188"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 73.375,
    cy: 50,
    r: 1.959
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.029,
    cy: 57.704,
    r: 1.959
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.237,
    cy: 64.579,
    r: 1.959
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.324,
    cy: 69.759,
    r: 1.959
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.013,
    cy: 72.699,
    r: 1.959
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9968 -0.0794 0.0794 0.9968 -4.0326 2.3121)",
    cx: 27.045,
    cy: 51.843,
    rx: 1.959,
    ry: 1.959
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9968 -0.0794 0.0794 0.9968 -4.628 2.4912)",
    cx: 28.998,
    cy: 59.416,
    rx: 1.959,
    ry: 1.959
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9968 -0.0794 0.0794 0.9968 -5.1348 2.8556)",
    cx: 33.325,
    cy: 65.967,
    rx: 1.959,
    ry: 1.959
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9968 -0.0794 0.0794 0.9968 -5.4877 3.3713)",
    cx: 39.63,
    cy: 70.661,
    rx: 1.959,
    ry: 1.959
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9968 -0.0794 0.0794 0.9968 -5.6506 3.9762)",
    cx: 47.152,
    cy: 73.012,
    rx: 1.959,
    ry: 1.959
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9962 -0.0867 0.0867 0.9962 -3.713 2.567)",
    cx: 27.71,
    cy: 44.049,
    rx: 1.959,
    ry: 1.959
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9962 -0.0867 0.0867 0.9962 -3.079 2.8158)",
    cx: 30.892,
    cy: 36.872,
    rx: 1.959,
    ry: 1.959
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9962 -0.0867 0.0867 0.9962 -2.567 3.266)",
    cx: 36.334,
    cy: 31.199,
    rx: 1.959,
    ry: 1.959
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9962 -0.0867 0.0867 0.9962 -2.2318 3.8617)",
    cx: 43.363,
    cy: 27.636,
    rx: 1.959,
    ry: 1.959
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Spinner_x5F_50_x25_"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Spinner_x5F_75_x25_"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Brightest_x5F_25_x25_"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Brightest_x5F_50_x25_"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Brightest_x5F_75_x25_"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Brightest_x5F_100_x25_"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Reload"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Forbidden"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Clock"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Compass"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "World"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Speed"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Microphone"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Options"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Chronometer"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Lock"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "User"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Position"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "No_x5F_Signal"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Low_x5F_Signal"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Mid_x5F_Signal"
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "High_x5F_Signal"
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "Options_1_"
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "Flash"
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "No_x5F_Signal_x5F_02"
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "Low_x5F_Signal_x5F_02"
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "Mid_x5F_Signal_x5F_02"
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "High_x5F_Signal_x5F_02"
  })), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "Favorite"
  })), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "Search"
  })), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "Stats_x5F_01"
  })), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "Stats_x5F_02"
  })), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "Turn_x5F_On_x5F_Off"
  })), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "Full_x5F_Height"
  })), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "Full_x5F_Width"
  })), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "Full_x5F_Screen"
  })), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "Compress_x5F_Screen"
  })), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "Chat"
  })), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "Bluetooth"
  })), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "Share_x5F_iOS"
  })), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "Share_x5F_Android"
  })), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "Love__x2F__Favorite"
  })), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "Hamburguer"
  })), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "Flying"
  })), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "Take_x5F_Off"
  })), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "Land"
  })), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "City"
  })), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "Nature"
  })), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "Pointer"
  })), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "Prize"
  })), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    id: "Extract"
  })), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    id: "Play"
  })), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    id: "Pause"
  })), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    id: "Stop"
  })), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    id: "Forward"
  })), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    id: "Reverse"
  })), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    id: "Next_1_"
  })), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    id: "Last_1_"
  })), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    id: "Empty_x5F_Basket"
  })), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    id: "Add_x5F_Basket"
  })), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    id: "Delete_x5F_Basket"
  })), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    id: "Error_x5F_Basket"
  })), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    id: "OK_x5F_Basket"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingIcon);
export default __webpack_public_path__ + "static/media/loading-icon.c51882edc39b8fbbbca9811eb98dab75.svg";
export { ForwardRef as ReactComponent };